import { render, staticRenderFns } from "./NotEnoughData.vue?vue&type=template&id=2d89e53e&scoped=true&"
import script from "./NotEnoughData.vue?vue&type=script&lang=js&"
export * from "./NotEnoughData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d89e53e",
  null
  
)

export default component.exports